import { useSelector } from 'react-redux';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { useGetFormConfigQuery } from '@/features/config/configApi';
import { isProspectFieldVisible, VIEW_TYPES } from '@/features/config/helper';

export const referralStatusFields = ['lifeInsuranceReferralStatus', 'kiwiSaverReferralStatus'];

export const useReferralStatusFields = () => {
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;
	const { data: userDetails } = useGetUserDetailsQuery({ email }, { skip: !email });

	const query = useGetFormConfigQuery(
		{ configType: 'client' },
		{
			skip: !userDetails,
			selectFromResult: ({ data, ...rest }) => ({
				...rest,
				data:
					data?.filter(
						(f) =>
							referralStatusFields.includes(f.name) &&
							(Boolean(f.visible?.[VIEW_TYPES.update]) ||
								isProspectFieldVisible(f, VIEW_TYPES.update)),
					) ?? [],
			}),
		},
	);

	return query.data ?? [];
};
